import React from "react";
import { Button } from "@telia/teddy";
import { connect } from "react-redux";
import { FORM_ID } from "../../../../../../constants";
import { RootState } from "../../../../../../models";
import { selectors as AUTH_SELECTORS } from "../../../../authentication";
import * as CHECKOUT_AT from "../../../../checkout/state/actionTypes";
import { selectors as LOADING_SELECTORS } from "../../../../loading";
import TEXT from "../../../text-consts";

interface StateProps {
    isBankIdAvailable: boolean;
    isBankIdMandatory: boolean;
    isBankIdVerified: boolean;
    isSettingPersonalDetails: boolean;
}
type ConfirmIdContinueButtonProps = StateProps;

const ConfirmIdContinueButton: React.FC<ConfirmIdContinueButtonProps> = ({
    // Redux (data)
    isSettingPersonalDetails,
    isBankIdAvailable,
    isBankIdVerified,
    isBankIdMandatory,
}) => (
    <Button
        form={FORM_ID.TRANSFER_OWNERSHIP}
        id="confirm-id-continue-button"
        loading={isSettingPersonalDetails}
        disabled={!isBankIdVerified || (!isBankIdAvailable && isBankIdMandatory)}
        type="submit"
    >
        {TEXT.COMMON.CONTINUE}
    </Button>
);

const mapStateToProps: (state: RootState) => StateProps = (state) => ({
    isSettingPersonalDetails: LOADING_SELECTORS.isTypeLoading(
        state,
        CHECKOUT_AT.CHECKOUT_SET_TRANSFER_OWNER_PERSONAL_DETAILS,
    ),
    isBankIdVerified: AUTH_SELECTORS.isBankIdVerified(state),
    isBankIdAvailable: AUTH_SELECTORS.isBankIdAvailable(state),
    isBankIdMandatory: AUTH_SELECTORS.isBankIdMandatory(state),
});

export default connect(mapStateToProps)(ConfirmIdContinueButton);
